var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSelectAll = function SvgSelectAll(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.121 28.5h-21a2 2 0 0 1-2-2v-21a2 2 0 0 1 2-2h13.715a2 2 0 0 1 0 4H8.121v17h17v-4.47a2 2 0 0 1 4 0v6.47a2 2 0 0 1-2 2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.015 20.637a2 2 0 0 1-1.414-.586l-4.969-4.968a2 2 0 1 1 2.828-2.828l3.555 3.554 9.875-9.875a2 2 0 1 1 2.828 2.828l-11.289 11.29a2 2 0 0 1-1.414.585"
  })));
};
export default SvgSelectAll;